import { createZodDto } from "nestjs-zod/dto";
import z from "zod";
import { userSchema } from "../user";
import { rateSchema } from "../rate";

export const couponSchema = z.object({
  id: z.string(),
  code: z.string(),
  reduction: z.number().min(0).max(100),
  userId: z.string().nullable().default(null),
  startDate: z.coerce.date(),
  endDate: z.coerce.date(),
  type: z.number(),
  rateId: z.string().nullable().default(null),
  status: z.number().default(0),
});

export class CouponDto extends createZodDto(couponSchema) {}
export const couponSchemaWithUserAndRate = couponSchema.merge(
  z.object({
    ambassador: userSchema.nullable().default(null),
    rate: rateSchema.nullable().default(null),
  }),
);

export class CouponWithUserAndRate extends createZodDto(couponSchemaWithUserAndRate) {}
